import React, { useState } from "react";
import InviteTeamMemberDialog from "components/InviteTeamMemberDialog";
import { Modal } from "react-responsive-modal";

export default ({ inviteMember, setInviteMember, children, teamId }) => {
  const [showInviteMembersDialog, setShowInviteMembersDialog] = useState(
    inviteMember ?? false
  );

  const closeInviteMemberDialog = () => {
    if (inviteMember) {
      setInviteMember(false);
    }
    setShowInviteMembersDialog(false);
  };

  return (
    <>
      <div
        className="invite-members"
        onClick={() => setShowInviteMembersDialog(true)}
      >
        {children}
      </div>
      <Modal
        showCloseIcon={false}
        open={showInviteMembersDialog}
        onClose={closeInviteMemberDialog}
        classNames={{
          modalContainer: "modalContainer",
          modal: "rootModalContainer",
        }}
      >
        <InviteTeamMemberDialog
          closeDialog={closeInviteMemberDialog}
          teamId={teamId}
        />
      </Modal>
    </>
  );
};
